import { entityOaid, reportYear } from '../../util/util'
import httpManager from "../../util/common"

import EntityTitle from "../../entity/components/EntityTitle"
import CdPieChart from "../components/CdPieChart"
import CdBarChart from "../components/CdBarChart"
import CdCircularDiagram from "../components/CdCircularDiagram"
export default {
    components: { EntityTitle, CdPieChart, CdBarChart, CdCircularDiagram },
    data() {
        return {
            oaid: null,
            national_economic_industry_name: '',
            key: false
        }
    },
    methods: {
        getEntityOaid() {
            let self = this
            let oaid = this.$route.params.oaid
            entityOaid.oaid(oaid).then(result => {
              oaid =result
              self.oaid = result
              self.key = true
            })
        },
    },
    created() {
        this.getEntityOaid()
    },
}


// WEBPACK FOOTER //
// ./src/carbon/js/carbon_data.js